/**
 * Booking abstraction for the public website.
 *
 * Phase 1 deliberately does NOT build a booking engine — Addy HIS already has
 * one (AppointmentController + ScheduleController /availability). The website
 * only needs to hand off the right entity id, so every CTA goes through this
 * interface and no theme ever hard-codes a booking URL.
 *
 * Phase 5 swaps the demo implementation for one that talks to the real
 * availability + appointment endpoints. Nothing in the themes changes.
 */
export interface BookingProvider {
  /** Generic "đặt lịch" with no entity context. */
  openBooking(): void;

  /** Book a specific service — the service id must reach HIS unchanged. */
  bookService(serviceId: string): void;

  /** Book a specific doctor. */
  bookDoctor(doctorId: string): void;
}

export type BookingIntent = {
  kind: "generic" | "service" | "doctor";
  entityId?: string;
};

/**
 * Phase 1 implementation: records the intent and surfaces it, so the
 * acceptance criterion "booking CTA passes the correct ID" is observable
 * end-to-end before the real integration exists. It never fabricates a
 * confirmed appointment.
 */
export function createDemoBookingProvider(
  onIntent: (intent: BookingIntent) => void,
): BookingProvider {
  return {
    openBooking: () => onIntent({ kind: "generic" }),
    bookService: (serviceId: string) => onIntent({ kind: "service", entityId: serviceId }),
    bookDoctor: (doctorId: string) => onIntent({ kind: "doctor", entityId: doctorId }),
  };
}
